import { ColorType, getColorValue } from '@/theme/colors';

interface GetCmarkdownTextColorInput {
  color?: ColorType;
  opacity?: number;
}

export function getCmarkdownTextColor(input: GetCmarkdownTextColorInput): string | undefined {
  if (input.color) {
    return getColorValue(input.color, input.opacity);
  }

  if (input.opacity != null) {
    return getColorValue(ColorType.White, input.opacity);
  }

  return undefined;
}
